import { Button, Tooltip } from 'antd';
import { CopyOutlined, SoundOutlined } from '@ant-design/icons';
import { memo, ReactNode } from 'react';
import styles from '../Chat.module.scss';

export interface ChatMessageActionConfig {
  key: string;
  label: string;
  icon: ReactNode;
  onClick: () => void;
  ariaLabel?: string;
  tooltip?: string;
  disabled?: boolean;
}

interface Props {
  actions: ChatMessageActionConfig[];
}

const ChatMessageActions = ({ actions }: Props) => {
  return (
    <>
      {actions.map(({ key, label, icon, onClick, ariaLabel, tooltip, disabled }) => {
        const button = (
          <Button
            key={key}
            size="small"
            type="text"
            shape="circle"
            aria-label={ariaLabel || label}
            icon={icon}
            className={styles.messageActionButton}
            onClick={onClick}
            disabled={disabled}
          />
        );

        return tooltip ? (
          <Tooltip key={key} title={tooltip} placement="topLeft">
            {button}
          </Tooltip>
        ) : (
          button
        );
      })}
    </>
  );
};

export default memo(ChatMessageActions);

export function createCopyAction(onCopy: () => void) {
  return {
    key: 'copy',
    label: 'Copy message',
    icon: <CopyOutlined />,
    onClick: onCopy,
    ariaLabel: 'Copy message',
    tooltip: 'Copy message',
  } satisfies ChatMessageActionConfig;
}

export function createSpeakAction(onSpeak: () => void) {
  return {
    key: 'speak',
    label: 'Play message audio',
    icon: <SoundOutlined />,
    onClick: onSpeak,
    ariaLabel: 'Play message audio',
    tooltip: 'Read message aloud',
  } satisfies ChatMessageActionConfig;
}
